import { render, staticRenderFns } from "./partyBuilding.vue?vue&type=template&id=10d06921&scoped=true&"
import script from "./partyBuilding.vue?vue&type=script&lang=js&"
export * from "./partyBuilding.vue?vue&type=script&lang=js&"
import style0 from "./partyBuilding.vue?vue&type=style&index=0&id=10d06921&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d06921",
  null
  
)

export default component.exports